<p-table [columns]="controlHeaders" [value]="masterLists" selectionMode="single" [(selection)]="showcontrols"
  (onRowSelect)="controlRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let controlField of columns">
        <ng-template [ngIf]="controlField.showInGrid">
          <th id="{{controlField.field+'Column'}}" [pSortableColumn]="controlField.field == 'lab' ? controlField.sort:controlField.field">
            {{controlField.header}}
            <p-sortIcon [field]="controlField.field == 'lab' ? controlField.sort:controlField.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let controlCol of columns">
        <ng-template [ngIf]="controlCol.showInGrid">
          <td *ngIf="controlCol.field != 'lab' && controlCol.field != 'active'" class="wrapword">
            {{rowData[controlCol.field]}}
          </td>
          <td *ngIf="controlCol.field == 'active'">
            <p-checkbox disabled [(ngModel)]="rowData[controlCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="controlCol.field=='lab'">
            {{rowData[controlCol.field]!= null? rowData[controlCol.field].name :''}}
          </td>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="addNewControlConfiguration()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style.width]="'800px'"position="top" baseZIndex="10"
  (onHide)="this.showcontrols = false;">
  <div *ngIf="masterList">
    <div *ngFor="let controlField of controlHeaders">
      <div class="form-group m-2">
        <div>
          <label>{{controlField.header}}</label>
        </div>
        <div *ngIf="controlField.field == 'controlConfigurationName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[controlField.field]"
            [ngClass]="{error:masterList[controlField.field+'Error']}" [placeholder]="controlField.header">
        </div>

        <div *ngIf="controlField.field == 'lab'">
          <p-dropdown [options]="_labOptions" [(ngModel)]="masterList[controlField.field]" [filter]="true"
            placeholder="Select a Lab" optionLabel="name" [showClear]="true"
            [styleClass]="masterList[controlField.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="controlField.field == 'numberOfPC'">          
          <p-spinner size="3" size="3" [(ngModel)]="masterList.numberOfPC" (ngModelChange)="getValueFromSpinner('numberOfPC')" [min]="0" [max]="10">
          </p-spinner>
        </div>
        <div *ngIf="controlField.field == 'numberOfPC'">
          <span *ngFor="let n of masterList.positiveExtractionControl; let i = index">             
            {{regexFormat}} :{{i+1}}
            <div>
              <input pInputText class="form-control" [(ngModel)]="masterList.positiveExtractionControl[i].regexFormat">
            </div>
            {{position}}:
            <div>
              <input pInputText class="form-control" [(ngModel)]="masterList.positiveExtractionControl[i].position">
            </div>
            Fixed:
            <div>
              <p-checkbox [(ngModel)]="masterList.positiveExtractionControl[i].fixed"  binary="true"></p-checkbox>
            </div>
          </span>
        </div>

        <div *ngIf="controlField.field == 'numberOfNC'">
          <p-spinner size="3" [(ngModel)]="masterList.numberOfNC" (ngModelChange)="getValueFromSpinner('numberOfNC')"
            [min]="0" [max]="10"></p-spinner>
        </div>
        <div *ngIf="controlField.field == 'numberOfNC'">
          <span *ngFor="let n of masterList.negativeExtractionControl; let i = index">
            {{regexFormat}} :{{i+1}}
            <input pInputText class="form-control" [(ngModel)]="masterList.negativeExtractionControl[i].regexFormat">
            {{position}}:
            <input pInputText class="form-control" [(ngModel)]="masterList.negativeExtractionControl[i].position">
            Fixed:
            <div>
              <p-checkbox [(ngModel)]="masterList.negativeExtractionControl[i].fixed"  binary="true"></p-checkbox>
            </div>
          </span>

        </div>
        <div *ngIf="controlField.field == 'numberOfPositivePCR'">
          <p-spinner size="3" [(ngModel)]="masterList.numberOfPositivePCR"
            (ngModelChange)="getValueFromSpinner('numberOfPositivePCR')" [min]="0" [max]="10"></p-spinner>
        </div>
        <div *ngIf="controlField.field == 'numberOfPositivePCR'">
          <span *ngFor="let n of masterList.positivePCRControls; let i = index">
            {{regexFormat}} :{{i+1}}
            <input pInputText class="form-control" [(ngModel)]="masterList.positivePCRControls[i].regexFormat">
            {{position}}:
            <input pInputText class="form-control" [(ngModel)]="masterList.positivePCRControls[i].position">
            Fixed:
            <div>
              <p-checkbox [(ngModel)]="masterList.positivePCRControls[i].fixed"  binary="true"></p-checkbox>
            </div>
          </span>
        </div>
        <div *ngIf="controlField.field == 'numberOfNegativePCR'">
          <p-spinner size="3" [(ngModel)]="masterList.numberOfNegativePCR"
            (ngModelChange)="getValueFromSpinner('numberOfNegativePCR')" [min]="0" [max]="10"></p-spinner>
        </div>

        <div *ngIf="controlField.field == 'numberOfNegativePCR'">
          <span *ngFor="let n of masterList.negativePCRControls; let i = index">
            {{regexFormat}} :{{i+1}}
            <input pInputText class="form-control" [(ngModel)]="masterList.negativePCRControls[i].regexFormat">
            {{position}}:
            <input pInputText class="form-control" [(ngModel)]="masterList.negativePCRControls[i].position">
            Fixed:
            <div>
              <p-checkbox [(ngModel)]="masterList.negativePCRControls[i].fixed"  binary="true"></p-checkbox>
            </div>
          </span>
        </div>
        <div *ngIf="controlField.field == 'active'">
          <p-checkbox id="active" [(ngModel)]="masterList[controlField.field]"  binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabledControl()"
      (click)="controlSaveOrUpdate()" label="Save" style="height: 35px;" class="buttonclass float-right mt-4"></button>
  </div>
</p-dialog>